module.exports = __webpack_public_path__ + "img/ico-sources.ab9e783a.svg";